// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1499":"66765266","8009":"66765266","8390":"615668ea"}[chunkId] + ".chunk.css";
};